import React from 'react';
import { T } from '@testout/labsim-ui-atomics';
import styles from './HoverTile.module.less';
export default ({ id, text, onClick, children }) => {
    return (React.createElement(T.Button, { className: styles.btn, onClick: onClick, automationId: id, id: id, variation: T.ButtonVariation.Secondary },
        React.createElement("div", { className: styles.children }, children),
        React.createElement(T.Text.Span, { automationId: 'text', variation: T.Text.Variation.Body, className: styles.iconText }, text)));
};
//# sourceMappingURL=HoverTile.js.map